import angular from 'angular';

export class DeviceConfigSearchFormController {
  /*@ngInject*/
  constructor($scope, $state, $stateParams) {
    this.$state = $state;

    this.target = $stateParams.target || 'pms_service_code';
    this.value = $stateParams.value || '';
    this.inputPlaceHolder = '例: pms00000001';
    this.searched = !!$stateParams.target;
    this.stateName = $stateParams.stateName || $state.current.name.split('.')[1];
    this.linkTo = `oem_main.${this.stateName}`;

    $scope.$watch('$ctrl.target', newValue => {
      switch (newValue) {
        case 'pms_service_code':
          this.inputPlaceHolder = '例: pms00000001';
          break;
        case 'distribution_id_suffix':
          this.inputPlaceHolder = '例: 54A8（下４桁）';
          break;
        case 'management_id':
          this.inputPlaceHolder = '例: mgmt-id-1';
          break;
        case 'zip_code':
          this.inputPlaceHolder = '例: 102-0071';
          break;
        case 'location':
          this.inputPlaceHolder = '例: 東京都千代田区';
          break;
      }
    });
  }

  $onInit() {
  }

  search() {
    this.$state.go(this.linkTo,
      {
        company_id: 'search',
        target: this.target,
        value: this.value,
      },
      {reload: true}
    );
  }

  reset() {
    this.$state.go('oem_main.company_index', { stateName: this.stateName });
  }
}

export default angular.module('leptonApp.deviceConfigSearchForm', [])
  .component('deviceConfigSearchForm', {
    template: require('./device_config_search_form.html'),
    controller: DeviceConfigSearchFormController,
    bindings: {}
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/oem/device_config/search-form/device_config_search_form.component.js